import React from 'react';
import { Link } from 'react-router-dom';

function Footer({ isMobile = false }) {
  return (
    <div style={{ position: isMobile ? 'static' : 'fixed', left: 0, right: 0, bottom: isMobile ? 'auto' : 0, background: 'var(--color-brown-primary)', color: 'var(--color-cream)', padding: '1em 0', textAlign: 'center', zIndex: 100 }}>
      <div style={{ marginBottom: '0.5em' }}>
        <Link to="/clip-install" style={{ color: 'var(--color-cream)', marginRight: '2em', fontWeight: 'bold', textDecoration: 'none' }}>Clip Installation</Link>
        <Link to="/about-us" style={{ color: 'var(--color-cream)', marginRight: '2em', fontWeight: 'bold', textDecoration: 'none' }}>About Us</Link>
        <Link to="/dendrometer-fundamentals" style={{ color: 'var(--color-cream)', marginRight: '2em', fontWeight: 'bold', textDecoration: 'none' }}>Dendrometer Fundamentals</Link>
        <Link to="/contact-us" style={{ color: 'var(--color-cream)', fontWeight: 'bold', textDecoration: 'none' }}>Contact Us!</Link>
      </div>
      {!isMobile && (
        <div style={{ fontSize: '0.8em', color: 'rgba(254, 253, 251, 0.85)', marginBottom: '0.5em' }}>
          <Link to="/privacy-policy" style={{ color: 'rgba(254, 253, 251, 0.85)', marginRight: '2em', textDecoration: 'none' }}>Privacy Policy</Link>
          <Link to="/terms-conditions" style={{ color: 'rgba(254, 253, 251, 0.85)', textDecoration: 'none' }}>Terms & Conditions</Link>
        </div>
      )}
      <div style={{ fontSize: '0.85em', color: 'rgba(254, 253, 251, 0.7)', marginTop: '0.5em' }}>© 2026 Canopy Biosystems Inc</div>
    </div>
  );
}

export default Footer;
